import {
    TOGGLE_SELECTED,
    TOGGLE_TO_DESELECT,
    CHANGE_EXCLUSION,
    SET_SHOW_BULK_OPTIONS,
    CHANGE_SORT_OPTION,
    CHANGE_CHANNEL,
    CHANGE_MEDIA,
    CHANGE_INFLUENCER_TYPE,
    CHANGE_SENTIMENT,
    CHANGE_SENTIMENT_TYPE,
    CHANGE_GROUPING,
    CHANGE_POST_TYPE,
    CHANGE_SAMPLING,
    TOGGLE_SELECT_ALL,
    RESET_REFINE_FILTER_OPTIONS,
    RESET_ALL_EXCEPT_ADDTIONALPARAM,
} from "../actions/refineFilterAction";

const refineFilterReducer = (
    state = {
        selectedPosts: [],
        deselectedPosts: [],
        showBulkOptions: false,
        filterSortValue: "published_date_desc",
        sentiment: "ALL",
        sentimentType: "ALL",
        media: "ALL",
        channel: "ALL",
        exclusion: "yes",
        grouping: "ALL",
        postType: "ALL",
        sampling: "100",
        influencers: [],
        selectAll: false,
        totalPostsSelected: false,
    },
    action,
) => {
    switch (action.type) {
        case TOGGLE_SELECTED: {
            let newSelectedPosts = null;
            if (state.selectedPosts.indexOf(action.payload) > -1) newSelectedPosts = state.selectedPosts.filter((id) => id !== action.payload);
            else newSelectedPosts = state.selectedPosts.concat([action.payload]);
            state = {
                ...state,
                selectedPosts: newSelectedPosts,
                totalPostsSelected: false,
                selectAll: false,
            };
            break;
        }
        case TOGGLE_TO_DESELECT: {
            let newDeselectedPosts = null;
            if (state.deselectedPosts.indexOf(action.payload) > -1) newDeselectedPosts = state.deselectedPosts.filter((id) => id !== action.payload);
            else newDeselectedPosts = state.deselectedPosts.concat([action.payload]);
            state = {
                ...state,
                deselectedPosts: newDeselectedPosts,
                totalPostsSelected: false,
                // selectAll: false
            };
            break;
        }
        case SET_SHOW_BULK_OPTIONS: {
            state = {
                ...state,
                showBulkOptions: !state.showBulkOptions,
                selectedPosts: state.showBulkOptions ? [] : state.selectedPosts,
            };
            break;
        }
        case CHANGE_SORT_OPTION:
            state = {
                ...state,
                filterSortValue: action.payload,
            };
            break;
        case CHANGE_EXCLUSION:
            state = {
                ...state,
                exclusion: action.payload,
            };
            break;
        case CHANGE_CHANNEL:
            state = {
                ...state,
                channel: action.payload,
            };
            break;
        case CHANGE_MEDIA:
            state = {
                ...state,
                media: action.payload,
            };
            break;
        case CHANGE_SENTIMENT:
            state = {
                ...state,
                sentiment: action.payload,
            };
            break;
        case CHANGE_INFLUENCER_TYPE:
            state = {
                ...state,
                influencers: action.payload,
            };
            break;
        case CHANGE_SENTIMENT_TYPE:
            state = {
                ...state,
                sentimentType: action.payload,
            };
            break;

        case CHANGE_GROUPING:
            state = {
                ...state,
                grouping: action.payload,
            };
            break;
        case CHANGE_POST_TYPE:
            state = {
                ...state,
                postType: action.payload,
            };
            break;
        case CHANGE_SAMPLING:
            state = {
                ...state,
                sampling: action.payload,
            };
            break;
        case TOGGLE_SELECT_ALL:
            state = {
                ...state,
                totalPostsSelected: !state.totalPostsSelected,
                selectAll: action.payload !== undefined ? action.payload : !state.totalPostsSelected,
                selectedPosts: [],
                deselectedPosts: [],
            };
            break;
        case RESET_ALL_EXCEPT_ADDTIONALPARAM: {
            let resetState = {
                filterSortValue: "published_date_desc",
                influencers: [],
                sentiment: "ALL",
                sentimentType: "ALL",
                media: "ALL",
                channel: "ALL",
                grouping: "ALL",
                postType: "ALL",
                sampling: "100",
                exclusion: "yes",
            };
            if (action.payload.key == "sentiment") {
                if (action.payload.value === state["sentiment"]) delete resetState["sentiment"];
                else resetState["sentiment"] = action.payload.value;
            }
            if (action.payload.key == "channel") {
                if (action.payload.value === state["channel"]) delete resetState["channel"];
                else resetState["channel"] = action.payload.value;
            }
            if (action.payload.key == "media") {
                if (action.payload.value === state["media"]) delete resetState["media"];
                else resetState["media"] = action.payload.value;
            }
            if (action.payload.key == "filterSortValue") {
                delete resetState["filterSortValue"];
            }
            state = {
                ...state,
                ...resetState,
            };
            break;
        }
        case RESET_REFINE_FILTER_OPTIONS:
            state = {
                ...state,
                filterSortValue: "published_date_desc",
                influencers: [],
                sentiment: "ALL",
                sentimentType: "ALL",
                media: "ALL",
                channel: "ALL",
                grouping: "ALL",
                postType: "ALL",
                sampling: "100",
                exclusion: "yes",
            };
            break;
        default:
            return state;
    }
    return state;
};

export default refineFilterReducer;
